import { AHBMessage, AHBMessageThread } from "core/types";

function findRootId(
  message: AHBMessage,
  lookup: Map<string, AHBMessage>,
): string {
  let currentId = message.ref_message_id!;
  let parent = lookup.get(currentId);

  while (parent?.ref_message_id) {
    currentId = parent.ref_message_id;
    parent = lookup.get(currentId);
  }

  return parent ? currentId : message.message_id;
}

export function groupMessagesByThread(
  messages: AHBMessage[] = [],
): AHBMessageThread[] {
  if (messages.length === 0) {
    return [];
  }

  const lookup = new Map<string, AHBMessage>();
  const threads = new Map<string, AHBMessageThread>();

  for (const msg of messages) {
    lookup.set(msg.message_id, msg);
  }

  for (const msg of messages) {
    const rootId = msg.ref_message_id
      ? findRootId(msg, lookup)
      : msg.message_id;

    if (!threads.has(rootId)) {
      const rootMessage = lookup.get(rootId)!;
      threads.set(rootId, { chain: [], message: rootMessage });
    }

    if (msg.message_id !== rootId) {
      threads.get(rootId)!.chain.push(msg);
    }
  }

  for (const thread of threads.values()) {
    thread.chain.sort((a, b) => a.created_at - b.created_at);
  }

  return Array.from(threads.values());
}

export function getMostRecentThread(
  messages: AHBMessage[] = [],
): AHBMessageThread | undefined {
  const threads = groupMessagesByThread(messages);
  return threads.sort((a, b) => {
    const lastA = Math.max(
      a.message.created_at,
      ...a.chain.map((m) => m.created_at),
    );
    const lastB = Math.max(
      b.message.created_at,
      ...b.chain.map((m) => m.created_at),
    );
    return lastB - lastA;
  })[0];
}
